/**
 * Reserved for future auth-based redirects.
 * Home (`/`) is the public marketing landing — do not redirect to dashboard.
 */
export function AuthRedirector() {
  return null;
}
